<ng-container *ngIf="isLoading">
  <section class="hero is-fullheight">
    <section class="hero is-primary is-medium">
      <div class="hero-body">
        <div class="container">
          <h1 class="title has-text-centered">
            <svg role="img" height="82px" width="280px">
              <use xlink:href="#brand-horizontal" />
            </svg>
          </h1>
        </div>
      </div>
    </section>
    <div class="hero-body">
      <div class="container has-text-centered">
        <h2 class="subtitle">Retrieving your order ...</h2>
        <br />
        <div
          class="la-square-jelly-box la-color-change"
          style="margin-left: auto; margin-right: auto"
        >
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
    <div class="hero-foot"></div>
  </section>
</ng-container>

<ng-container *ngIf="!isLoading">
  <nav class="navbar is-primary is-mobile" role="navigation" aria-label="main navigation">
    <div class="navbar-brand is-justify-content-center" style="max-height: 58px">
      <div class="navbar-item" href="#">
        <svg role="img" height="100%" width="100%">
          <use xlink:href="#brand-horizontal" />
        </svg>
      </div>
    </div>
  </nav>
  <router-outlet></router-outlet>
</ng-container>

<footer class="footer">
  <div class="content has-text-centered">
    <p>©{{ currentYear }} Wakefern Food Corp, Inc. All Rights Reserved</p>
  </div>
</footer>
